<template>
  <div class="md-card md-card-pricing" :class="cardClass">
    <slot name="category"></slot>
    <div class="md-card-content">
      <div class="md-card-icon" :class="iconColor">
        <slot name="icon"></slot>
      </div>
      <slot name="title"></slot>
      <slot name="description"></slot>
    </div>
    <div class="md-card-actions text-center">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "pricing-card",
  props: {
    cardClass: {
      type: String,
      default: "",
    },
    iconColor: {
      type: String,
      default: "",
    },
  },
};
</script>
<style></style>
